module.exports = __webpack_public_path__ + "media/images/players/REED_PATRICK-36dd7fd449e60f362bbd456d31d85408.png";